/**
 * Mouse drag for positioning preview elements.
 * Evaluates the expression with $phase ("start" | "move" | "end") and $dx/$dy:
 * the pointer offset in screen px from where the drag started.
 * Usage: <div drag-move="ctrl.onDrag(item, $phase, $dx, $dy)"></div>
 */
class dragMoveDirective {
    constructor($parse) {
        "ngInject";
        this.restrict = "A";
        this.$parse = $parse;
    }

    link(scope, element, attrs) {
        const handler = this.$parse(attrs.dragMove);
        let startX = 0;
        let startY = 0;

        const call = (phase, event) => {
            scope.$applyAsync(() => handler(scope, {
                $phase: phase,
                $dx: event.clientX - startX,
                $dy: event.clientY - startY
            }));
        };
        const onMove = (event) => {
            event.preventDefault();
            call("move", event);
        };
        const onUp = (event) => {
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseup", onUp);
            call("end", event);
        };
        const onDown = (event) => {
            if (event.button !== 0 || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            startX = event.clientX;
            startY = event.clientY;
            call("start", event);
            document.addEventListener("mousemove", onMove);
            document.addEventListener("mouseup", onUp);
        };

        element.on("mousedown", onDown);
        scope.$on("$destroy", () => {
            element.off("mousedown", onDown);
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseup", onUp);
        });
    }

    static create() {
        return new dragMoveDirective(...arguments);
    }
}

dragMoveDirective.create.$inject = ["$parse"];

export {dragMoveDirective};



// WEBPACK FOOTER //
// ./sources/directives/drag-move.directive.js